<div class="colmec-filter">
  <div class="colmec-f-label" translate>
    {{ renderFilter.name }}
  </div>
  <div class="filter-dropdown" ngbDropdown [autoClose]="'outside'" (openChange)="handleDropdownOpen($event)">
    <button class="btn btn-block text-left top-filter-dropdown" ngbDropdownToggle>
      <div class="d-flex align-items-center">
        <span translate>
          {{ renderFilter.name }}
        </span>
        <i
          class="fa float-right ml-2"
          [ngClass]="{ 'fa-chevron-down': !dropdownIsOpen, 'fa-chevron-up': dropdownIsOpen }"
        ></i>
      </div>
    </button>
    <ul class="top-filter-dropdown-list" ngbDropdownMenu>
      <li *ngIf="renderFilter.valueList.length > 0">
        <lib-filter-list-search (searchUpdated)="setSearch($event)"></lib-filter-list-search>
      </li>
      <li *ngIf="renderFilterValueList == 0">
        <span translate>NO_RESULTS_FOUND</span>
      </li>
      <li *ngFor="let option of renderFilterValueList" [ngClass]="{ 'd-none': !option.valueId || option.hide }">
        <button
          class="btn top-filter-item w-100 text-left"
          (click)="option.selected ? deselectValue.emit(option.valueId) : selectValue.emit(option.valueId)"
          translate
        >
          <i class="far" [ngClass]="{ 'fa-square': !option.selected, 'fa-check-square': option.selected }"></i>
          {{ option.valueName }} <span class="float-right">{{ option.itemCountAfterFilter }}</span>
        </button>
      </li>
    </ul>
  </div>
</div>
